<template>
    <div>
        <h1 :style="titleColorStyle" v-if="title" v-zoezi-editable="{prop: 'title', multiline: false, html: false}">{{title}}</h1>
        <p v-if="text" v-html="textCompiled" :style="textColorStyle" v-zoezi-editable="{prop: 'text', multiline: true, html: true}"></p>
    </div>
</template>

<script>
export default {
    name: 'zoezi-text',

    zoezi: {
        title: 'Text and headline',
        icon: 'mdi-card-text-outline',
        getDefaultStyle: () => ({
            margin: 12
        })
    },

    props: {
        title: {
            title: 'Headline',
            type: String,
            default: 'Rubrik'
        },
        text: {
            title: 'Text in markdown',
            type: String,
            default: 'Text'
        },
        titleColor: {
            title: 'Header color',
            type: String,
            fulltype: 'color'
        },
        textColor: {
            title: 'Textfärg',
            type: String,
            fulltype: 'color'
        }
    },

    computed: {
        textCompiled() {
            return this.text;
        },
        titleColorStyle() {
            if (this.titleColor) {
                return {color: this.$root.colorToHex(this.titleColor)};
            }
            return null;
        },
        textColorStyle() {
            if (this.textColor) {
                return {color: this.$root.colorToHex(this.textColor)};
            }
            return null;
        }
    },
    migrations: [
        (props) => {
            if (typeof props.text === 'object') {
                props.text = props.text?.sv;
            }
            if (typeof props.title === 'object') {
                props.title = props.title?.sv;
            }
        }
    ]
}
</script>
